/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { OperationStatus } from "Constants/OperationStatus";
import { IAvailableCpmData } from "Interfaces/SiteContent/IAvailableCpmData";
import { IAvaiableCpmOptionList } from "Interfaces/SiteContent/IAvailableCpmOptionList";
import { ICommonDataState } from "Interfaces/SiteContent/ICommonDataState";
import { IReviewStatusData } from "Interfaces/SiteContent/IReviewStatusData";
import { IReviewStatusOptionList } from "Interfaces/SiteContent/IReviewStatusOptionList";

/**
 * Selector for mvp review statuses.
 */
export const getMvpReviewStatuses = (state: ICommonDataState): IReviewStatusData[] =>
  state.mvp.reviewStatuses;

/**
 * Selector for mvp review statuses option list.
 */
export const getMvpReviewStatusOptionList = (state: ICommonDataState): IReviewStatusOptionList[] =>
  state.mvp.reviewStatusOptionList;

/**
 * Selector for common data operation status.
 */
export const getCommonDataLoadStatus = (state: ICommonDataState): OperationStatus =>
  state.commonDataOperationStatus;

/**
 * Selector for common data load error.
 */
export const getCommonDataLoadError = (state: ICommonDataState): string =>
  state.commonDataLoadError;

/**
 * Selector for available Mvp Cpm list.
 */
export const getMvpAvailableCpms = (state: ICommonDataState): IAvailableCpmData[] =>
  state.mvp.availableCpms;

/**
 * Selector for available Mvp Cpm option list.
 */
export const getMvpAvailableCpmOptionList = (state: ICommonDataState): IAvaiableCpmOptionList[] =>
  state.mvp.availableCpmOptionList;

/**
 * Selector for available Msa Cpm list.
 */
export const getMlsaAvailableCpms = (state: ICommonDataState): IAvailableCpmData[] =>
  state.mlsa.availableCpms;

/**
 * Selector for available Msa Cpm option list.
 */
export const getMlsaAvailableCpmOptionList = (state: ICommonDataState): IAvaiableCpmOptionList[] =>
  state.mlsa.availableCpmOptionList;
